class SaleStripProduct extends HTMLElement {
  constructor() {
    super();
    this.endTime = Date.parse(this.dataset.endDatetime);
    this.textEl = this.querySelector('[data-countdown-text]');
    // day+hour+minute (sticky strip) vs day+hour only (product-page
    // low-stock urgency line) — see data-show-minutes on each usage.
    this.showMinutes = this.hasAttribute('data-show-minutes');
    // "Xd : 0Xh : 0Xm" — used by the price-row countdown badge.
    this.colonFormat = this.hasAttribute('data-colon-format');
    // Adds a ticking "0Xs" unit (price-row badge only) — everything else
    // stays on the coarser 60s interval below it, since a minutes-only
    // display gains nothing from per-second updates.
    this.showSeconds = this.hasAttribute('data-show-seconds');
  }

  connectedCallback() {
    if (isNaN(this.endTime)) return;
    this.tick();
    this.interval = setInterval(this.tick.bind(this), this.showSeconds ? 1000 : 60000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      // Hides whatever surrounding "· Ends in ..." / "· Sale ends in ..."
      // clause this element wraps, not just the digits, so nothing dangles.
      this.hidden = true;
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let label;
    if (this.colonFormat) {
      label = `${days}d : ${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m`;
      if (this.showSeconds) {
        label += ` : ${String(seconds).padStart(2, '0')}s`;
      }
    } else if (this.showMinutes) {
      label = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
    } else if (days > 0) {
      label = `${days}d ${hours}h`;
    } else if (hours > 0) {
      label = `${hours}h ${minutes}m`;
    } else {
      label = `${minutes}m`;
    }

    this.textEl.textContent = label;
  }
}

// Guarded like cart.js's cart-note element — this script can legitimately
// load twice on the same product page (once from the sticky sale strip
// section, once from the low-stock urgency line near Add to Cart), and a
// second customElements.define() call for the same tag throws.
if (!customElements.get('sale-strip-product')) {
  customElements.define('sale-strip-product', SaleStripProduct);
}
